import React from 'react';
import { subscribe } from 'react-contextual';
import PartnerLogo from "../common/partnerLogo";

const handleNavLinkClick = function () {
    window.location.href = '/';
};

const WGNavToggler = ({ logo, isOpen }) => (
    <div className="d-flex" onClick={handleNavLinkClick}>
        {isOpen ? <div>
                { <PartnerLogo w="100%" className={"wg-login-partner-logo"} /> }
            </div>
            :
            <div>
                {logo === 'color' || !logo ?<PartnerLogo w="100%" className={"wg-login-partner-logo"} /> : null }
                {logo === 'white' ? <PartnerLogo w="100%" className={"wg-login-partner-logo"} /> : null }
                {logo === 'black' ? <PartnerLogo w="100%" className={"wg-login-partner-logo"} /> : null }
            </div>}
        <style jsx global>{`
        .wg-login-partner-logo {
        max-width: 100px;
        }
        `}</style>
    </div>
);

export default subscribe()(WGNavToggler);
